<div class="work-area">
  <div>
    <app-alert></app-alert>
  </div>
  <div id="processing-settings">
    <div>
      <div id="gds-settings" >
        <h5>GDS Settings</h5>
        <div>
          <div *ngIf="isQuickAudit" class="addMargin" >
                  Rate Access Code:
          </div>
          <div>
            <ngl-checkbox label="Amadeus" *ngIf="!isQuickAudit">
              <input ngl type="checkbox" name="Amadeus" [disabled]="disableAuditAmadeus" [(ngModel)]="editedAudit.AuditAmadeus"
              />
            </ngl-checkbox>
            <div *ngIf="!isQuickAudit" >
              <span *ngIf="gdsCredentials.AmadeusActive">
                <strong>Office ID:</strong> {{gdsCredentials.AmadeusCredentials.OfficeID}}
                <strong>Organization:</strong> {{gdsCredentials.AmadeusCredentials.Organization}}
              </span>
              <span *ngIf="showNotAvailableAmadeus">Amadeus was requested to be processed by the input file. However Amadeus is not active for your account.</span>
            </div>
            <div *ngIf="isQuickAudit">
              <label title="">Amadeus </label>
              <input type="text" maxlength=255 id="txtAmadeus" class="upperCaseOnly gdsInput"
                [disabled]="disableAuditAmadeus || !editedAudit.AuditAmadeus" [(ngModel)]="racAmadeus" (change)="racCodeChanged($event)" />
              <span *ngIf="disableAuditAmadeus" class="cvt-icon-information"
                title="Unavailable, contact sales to enable"></span>
            </div>
          </div>
          <div>
            <ngl-checkbox label="Apollo" *ngIf="!isQuickAudit">
              <input ngl type="checkbox" name="Apollo" [disabled]="disableAuditApollo" [(ngModel)]="editedAudit.AuditApollo"
              />
            </ngl-checkbox>
            <div *ngIf="!isQuickAudit">
              <span *ngIf="gdsCredentials.ApolloActive">
                <strong>Profile:</strong> {{gdsCredentials.ApolloCredentials.Profile}}
              </span>
              <span *ngIf="showNotAvailableApollo">Apollo was requested to be processed by the input file. However Apollo is not active for your account.</span>
            </div>
            <div *ngIf="isQuickAudit">
              <label title="">Apollo </label>
              <input type="text" maxlength=255 id="txtApollo" class="upperCaseOnly gdsInput"
                [disabled]="disableAuditApollo || !editedAudit.AuditApollo" [(ngModel)]="racApollo" (change)="racCodeChanged($event)" />
              <span *ngIf="disableAuditApollo" class="cvt-icon-information"
                title="Unavailable, contact sales to enable"></span>
            </div>
          </div>
          <div>
            <ngl-checkbox label="Galileo" *ngIf="!isQuickAudit">
              <input ngl type="checkbox" name="Galileo" [disabled]="disableAuditGalileo" [(ngModel)]="editedAudit.AuditGalileo"
              />
            </ngl-checkbox>
            <div *ngIf="!isQuickAudit">
              <span *ngIf="gdsCredentials.GalileoActive">
                <strong>Profile:</strong> {{gdsCredentials.GalileoCredentials.Profile}}
              </span>
              <span *ngIf="showNotAvailableGalileo">Galileo was requested to be processed by the input file. However Galileo is not active for your account.</span>
            </div>
            <div *ngIf="isQuickAudit">
              <label title="">Galileo </label>
              <input type="text" maxlength=255 id="txtGalileo" class="upperCaseOnly gdsInput"
                [disabled]="disableAuditGalileo || !editedAudit.AuditGalileo" [(ngModel)]="racGalileo" (change)="racCodeChanged($event)" />
              <span *ngIf="disableAuditGalileo" class="cvt-icon-information"
                title="Unavailable, contact sales to enable"></span>
            </div>
          </div>
          <div>
            <ngl-checkbox label="Sabre" *ngIf="!isQuickAudit">
              <input ngl type="checkbox" name="Sabre" [disabled]="disableAuditSabre" [(ngModel)]="editedAudit.AuditSabre"
              />
            </ngl-checkbox>
            <div *ngIf="!isQuickAudit">
              <span *ngIf="gdsCredentials.SabreActive">
                <strong>Login ID:</strong> {{gdsCredentials.SabreCredentials.LoginId}}
                <strong>PCC:</strong> {{gdsCredentials.SabreCredentials.PCC}}
                <strong>Use AAA:</strong> {{gdsCredentials.SabreCredentials.UseAAA}}</span>
              <span *ngIf="showNotAvailableSabre">Sabre was requested to be processed by the input file. However Sabre is not active for your account.</span>
            </div>
            <div *ngIf="isQuickAudit">
              <label title=""> Sabre</label>
              <input type="text" maxlength=255 id="txtSabre" class="upperCaseOnly gdsInput"
                [disabled]="disableAuditSabre || !editedAudit.AuditSabre" [(ngModel)]="racSabre" (change)="racCodeChanged($event)" />
              <span *ngIf="disableAuditSabre" class="cvt-icon-information"
                title="Unavailable, contact sales to enable"></span>
            </div>
          </div>
          <div>
            <ngl-checkbox label="Worldspan"  *ngIf="!isQuickAudit">
              <input ngl type="checkbox" name="Worldspan" [disabled]="disableAuditWorldspan" [(ngModel)]="editedAudit.AuditWorldspan"
              />
            </ngl-checkbox>
            <div *ngIf="!isQuickAudit">
              <span *ngIf="gdsCredentials.WorldspanActive">
                <strong>Login ID:</strong> {{gdsCredentials.WorldspanCredentials.Session}}
                <strong>PCC:</strong> {{gdsCredentials.WorldspanCredentials.PCC}}
              </span>
              <span *ngIf="showNotAvailableWorldspan">Worldspan was requested to be processed by the input file. However Worldpsan is not active for your account.</span>
            </div>
            <div *ngIf="isQuickAudit">
              <label title=""> Worlspan </label>
              <input type="text" maxlength=255 id="txtWorldspan" class="upperCaseOnly gdsInput"
                [disabled]="disableAuditWorldspan || !editedAudit.AuditWorldspan" [(ngModel)]="racWorldspan" (change)="racCodeChanged($event)" />
              <span *ngIf="disableAuditWorldspan" class="cvt-icon-information"
                title="Unavailable, contact sales to enable"></span>
            </div>
          </div>
        </div>
      </div>
      <div id="audit-settings">
        <h5>Audit Settings</h5>
        <div>
          <div class="col1">
            <label title="">Account Name
              <input id="txtAccountName" type="text" maxlength=255 [(ngModel)]="editedAudit.AccountName" [disabled]="isQuickAudit" />
            </label>
            <label title="">Customer Account ID
              <input type="text"  [(ngModel)]="editedAudit.CustomerAccountID" />
            </label>
          </div>
          <div class="col1">
            <label title="">Contract Year
              <kendo-dropdownlist id="ddlContractYear" [data]="contractYearList" [(ngModel)]="contractYear" [valuePrimitive]="true" [allowCustom]="false" [popupSettings]="dropdownPopupSettings" [disabled]="isQuickAudit"></kendo-dropdownlist>
            </label>
            <label title="">Account Type
              <kendo-dropdownlist [data]="accountTypeList" valueField="id" textField="name" [(ngModel)]="accountType" [valuePrimitive]="true"
                [allowCustom]="false" [popupSettings]="dropdownPopupSettings"></kendo-dropdownlist>
            </label>

          </div>
          <div *ngIf="LOSIsLicensed">
            <fieldset ngl-radio-group label="Length of Stay Settings" class="">
              <ngl-radio-option label="2 Night">
                <input ngl type="radio" name="los2" value="2" [(ngModel)]="lengthOfStay" [checked]="lengthOfStay==='2'" />
              </ngl-radio-option>
              <ngl-radio-option label="3 Night">
                <input ngl type="radio" name="los3" value="3" [(ngModel)]="lengthOfStay" [checked]="lengthOfStay==='3'" /> </ngl-radio-option>
              <ngl-radio-option label="5 Night">
                <input ngl type="radio" name="los4" value="5" [(ngModel)]="lengthOfStay" [checked]="lengthOfStay==='5'" /> </ngl-radio-option>
              <ngl-radio-option label="7 Night">
                <input ngl type="radio" name="los5" value="7" [(ngModel)]="lengthOfStay" [checked]="lengthOfStay==='7'" /> </ngl-radio-option>
              <ngl-radio-option id="custom-LOS" label="Custom">
                <input ngl name="customlos" type="radio" value="-1" [(ngModel)]="lengthOfStay" [checked]="lengthOfStay==='-1'"
                />
              </ngl-radio-option>
              <input type="text" [maxLength]="2" [(ngModel)]="customeLengthOfStay" [disabled]="lengthOfStay!=='-1'"  />&emsp; max 99
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div id="rate-finder-keywords">
        <h5>Comparison Keywords</h5>
        <p>Keywords are used for rate identification and verification. They are compared against the Rate Access Codes, Rate Descriptions, and
            Room Descriptions provided by a GDS. In order to make the provided keywords as efficient as possible, all "noise" characters and words
            are automatically removed as they reduce the probability of a successful match.
          </p>
          <p>For additional details along with a complete list of removed words and characters please refer to the Rate Integrity
          Manual or Quick Start Guide.</p>
        <div>
          <div>
            <label title="">Keyword To Add
              <input type="text" [(ngModel)]="keywordToAdd" class="upperCaseOnly" />
            </label>
            <button class="k-button cvt-primary" (click)="addKeyordClick()" [disabled]="invalidKeyword" >Add Keyword</button>
            <br/>
            <label>Original Imported Keyword List</label>
            <p class="originalKeyword">{{originalKeywordList}}</p>
          </div>
          <div class="keywordList">
            <app-configurable-link-list
            (deleteClickedOutput)="deleteKeyword($event)"
            [list]="keywordList">
            </app-configurable-link-list>
          </div>
          <select *ngIf="false" id="theSelect" size='13' class="iconFont">
            <option *ngFor="let item of keywordList " value="item">
              <a href="#">
                <span class="cvt-icon-closeDelete">&#xe934;</span>
              </a> {{item}}</option>
          </select>
        </div>
      </div>
      <div id="schedule-approvals">
        <h5>Audit Processing Details</h5>
        <form>
          <fieldset ngl-radio-group label="Schedule Audit" class="notslds-m-top--small">
            <ngl-radio-option label="Run Audit Now">
              <input ngl type="radio" name="runNow" [checked]="runAuditNow" (click)="updateScheduleType(0)" />
            </ngl-radio-option>
            <ngl-radio-option id="schedeuled-radio" label="Schedule Job to Run At:">
              <input ngl type="radio" name="scheduled" [checked]="auditWillBeScheduled" (click)="updateScheduleType(1)" /> </ngl-radio-option>
            <kendo-datepicker name="dpick" #dpick [disabled]="!auditWillBeScheduled" [value]="scheduledTime" (valueChange)="updateScheduledTime($event)" [min]="earliestRunDate" [max]="lastRunDate" ></kendo-datepicker>
            <kendo-timepicker name="tpick" #tpick [format]="'T'" [value]="scheduledTime" (valueChange)="updateScheduledTime($event)" [disabled]="!auditWillBeScheduled"></kendo-timepicker>
          </fieldset>
          <ngl-checkbox label="Audit Requires Approval Before Processing Can Start">
            <input ngl type="checkbox" name="requireApproval" [(ngModel)]="auditRequiresApprovalToStart" />
          </ngl-checkbox>
        </form>
        <div id="notifications">
          <div>
            <fieldset ngl-radio-group label="Select Audit Notification Template">
              <ngl-radio-option label="Do Not Build Notifications Packages">
                <input ngl type="radio" name="notBuildNotification" [(ngModel)]="buildNotification"
                  [value]="false" [checked]="!buildNotification" />
              </ngl-radio-option>
              <ngl-radio-option label="Build Notifications Packages">
                <input ngl type="radio" name="buildNotification" [(ngModel)]="buildNotification" [value]="true"
                  [checked]="buildNotification" />
              </ngl-radio-option>
              <kendo-dropdownlist #notifTemplate [data]="_notificationTemplateList" [disabled]="!buildNotification"
                valueField="id" textField="name" [(ngModel)]="notificationSelection" [valuePrimitive]="true"
                [allowCustom]="true" item-width="300">
                <ng-template *ngIf="!buildNotification" kendoDropDownListValueTemplate>
                  <span class="setColor">No Assigned Notification Template</span>
                </ng-template>
                <ng-template kendoDropDownListItemTemplate let-dataItem>
                  <span>{{dataItem.name}}</span>
                </ng-template>
              </kendo-dropdownlist>
            </fieldset>
            <div class="addPadding">
              <ngl-checkbox label="Validate Missing Property Emails">
                <input ngl type="checkbox" name="chkValidateEmail" [(ngModel)]="validateEmail"
                  (change)="OnCheckValueChange()" [disabled]="!buildNotification" />
              </ngl-checkbox>
            </div>
          </div>
          <div class="failedEmailContact">
            <label title="">Report Failed Emails To
              <input id="txtFailedEmailContactEmailAddress" type="text" maxlength=255 [(ngModel)]="editedAudit.AuditContactEmailAddress"
                 />
            </label>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
